import ThankYou from './thankyou'

export default ThankYou
